/* eslint-disable no-unused-vars */
import { createContext } from 'react'
import { initialState } from './reducer'

export const initialContextState = {
  state: initialState,
  actions: {
    /**
     *
     * @param {string} adAccountId
     */
    setAccountId: () => {},
    /**
     * @param {object} payload
     * @param {string} payload.search
     * @param {string} payload.order
     * @param {number} payload.current
     * @param {number} payload.size
     */
    setPagination: () => {},
    /**
     *
     * @param {string} adToken
     */
    setToken: async () => {},
    unsetToken: () => {},
    /**
     *
     * @param {'campaign'|'advertisement'} search
     */
    setSearch: () => {},

    /**
     * @param {object} advertisement
     * @param {boolean} advertisement.status
     * @param {boolean} advertisement.campaignStatus
     * @param {string} advertisement.campaignName
     * @param {string} advertisement.name
     * @param {string} advertisement.url
     * @param {string} advertisement.headline
     * @param {string} advertisement.mediaType
     * @param {string} advertisement.imageUrl
     * @param {string} advertisement.body
     */
    setAdsPreview: (advertisement) => {},
    unsetAdsPreview: () => {},
    setDate: () => {},
    cleanup: () => {},
    setCampaigns: () => {},
    setAds: () => {},
    setStatuses: () => {},
  },
}

export const ConversionReportContext = createContext(initialContextState)
